var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('field-input',{attrs:{"value":_vm.dimensions,"label":"Длина, высота, ширина (см)","placeholder":"100 100 100"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }